import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' 
})
export class LayoutService {

  private defaultUseNewLayout: boolean = false;

  private useNewLayoutSubject = new BehaviorSubject<boolean>(false);
  

  public useNewLayout$ = this.useNewLayoutSubject.asObservable();

  constructor(private router: Router) {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.evaluateUrl(event.urlAfterRedirects);
    });
  }


  public initialize(serverPreference: boolean): void {
    this.defaultUseNewLayout = serverPreference;
    this.evaluateUrl(this.router.url); 
  }


private evaluateUrl(url: string): void {
  const isWorkflowAppRoute = /\/application\/workflow-application\/[^\/]+/.test(url);
  
  const isRegisterRoute = /\/auth\/register(\?|#|$)/.test(url); 
  const isLoginRoute = /\/auth\/login(\?|#|$)/.test(url);
  const isApplicantApplicationRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/application\/[^\/]+/.test(url);

  const isAdminWorkflowAppDataRoute = /\/admin\/jurisdiction\/[^\/]+\/department\/[^\/]+\/workflow-applications\/data/.test(url);
  const isAdminContractorApplicationRoute = /\/admin\/jurisdiction\/[^\/]+\/department\/[^\/]+\/contractors\/all(?:[/?#]|$)/.test(url);
  const isApplicantMyWorkflowAppRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/my-applications\/workflow-application\/[^\/]+\/[^\/]+/.test(url);
    const isContractorsMyWorkflowAppRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/my-contractor-registrations\/workflow-application\/[^\/]+\/[^\/]+/.test(url);


  const isAdminWorkflowBuilderRoute = /\/admin\/workflow-builder\/[^\/]+/.test(url);

  const isAdminWorkflowAppsListRoute = /\/admin\/jurisdiction\/[^\/]+\/workflow-applications(\?|#|\/|$)/.test(url);
  const isApplyForPermitRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/apply-for-permit\/department\/[^\/]+\/application\/[^\/]+/.test(url);

  const isWorkflowApplicationRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/my-applications\/workflow-application\/[^\/]+/.test(url);

  const isChildWorkflowRoute = /\/jurisdiction\/[^\/]+\/applicant-home\/my-applications\/child-application\/[^\/]+/.test(url);

  let finalUseNewLayout = this.defaultUseNewLayout;


  if (isWorkflowAppRoute || isRegisterRoute || isLoginRoute || isAdminWorkflowBuilderRoute || isAdminWorkflowAppsListRoute) {
    finalUseNewLayout = false;
  }

 if (isApplicantApplicationRoute || isAdminWorkflowAppDataRoute || isAdminContractorApplicationRoute || isApplicantMyWorkflowAppRoute || isApplyForPermitRoute || isWorkflowApplicationRoute || isChildWorkflowRoute || isContractorsMyWorkflowAppRoute) {
    finalUseNewLayout = true;
  }
  
  this.useNewLayoutSubject.next(finalUseNewLayout);
}


  public get currentLayoutState(): boolean {
    return this.useNewLayoutSubject.value;
  }
}
